function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("line", {
  x1: 1,
  y1: 13,
  x2: 8,
  y2: 5,
  stroke: "currentColor",
  strokeWidth: 3
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 1,
  y1: 12,
  x2: 8,
  y2: 20,
  stroke: "currentColor",
  strokeWidth: 3
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 22,
  y1: 5,
  x2: 29,
  y2: 13,
  stroke: "currentColor",
  strokeWidth: 3
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  x1: 22,
  y1: 20,
  x2: 29,
  y2: 12,
  stroke: "currentColor",
  strokeWidth: 3
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  x1: 12,
  y1: 24,
  x2: 18,
  y2: 1,
  strokeLinecap: "round",
  stroke: "currentColor",
  strokeWidth: 3
});

function SvgAssetCodeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "25px",
    viewBox: "0 0 30 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Code Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetCodeIcon);
export default __webpack_public_path__ + "static/media/asset-code-icon.c73947cc.svg";
export { ForwardRef as ReactComponent };